<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>공지사항상세</h2>
            </div>

            <article class="view cmnity">
                <div class="cmnity_detail">
                    <div class="title_box">
                        <h3>
                            <span class="notice-impt-badge" v-if="noticeInfo.board_notice_impt_yn == 'Y'">중요</span>
                            {{ noticeInfo.board_notice_title }}
                        </h3>
                        <div class="info_box">
                            <div class="info-left">
                                <p>공지기간 <span>{{ noticeInfo.board_notice_start_dt }} ~ {{ noticeInfo.board_notice_end_dt }}</span></p>
                                <p>작성일 <span>{{ noticeInfo.reg_dt }}</span></p>
                            </div>
                            <div class="info-right">
                                <p>조회수 <span>{{ noticeInfo.read_cnt }}</span></p>
                            </div>
                        </div>
                    </div>

                    <div class="notice-content" v-html="noticeInfo.board_notice_cnts"></div>

                    <div class="file_area" v-if="noticeInfo.file_org_name">
                        <span class="file-label">첨부파일</span>
                        <a href="#" class="file-link" @click.prevent="fn_download_file(noticeInfo.file_id)">
                            <i class="icon icon_clip"></i>
                            {{ noticeInfo.file_org_name }}
                        </a>
                    </div>

                    <div class="bottom_box">
                        <button class="btn btn_md btn_darkbrown" @click="$router.push('/notice')">목록</button>
                    </div>
                </div>
            </article>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import commonUtil from '@/mixin/commonUtil'

export default {
    name: 'NoticeDetail',
    mixins: [commonUtil],
    data() {
        return {
            boardNoticeId : '',
            noticeInfo: {}
        }
    },
    created(){
      this.boardNoticeId = this.$store.getters['detailSearchInfo/getSearchId'];
      console.log("@@@@@ boardNoticeId : %o", this.boardNoticeId);
    },
    mounted() {
        this.fn_search()
    },
    methods: {
        fn_search() {

          let param = new Object();
          param.boardNoticeId = this.boardNoticeId;

          console.log("@@@@ param : %o", param);

            axios
                .post('/api/user/board/getNoticeDetail', param)
                .then((res) => {
                    this.noticeInfo = res.data.noticeInfo
                })
                .catch((err) => console.log(err))
        }
    }
}
</script>

<style scoped>
.notice-impt-badge {
    display: inline-block;
    background-color: #e53935;
    color: #fff;
    font-size: 1.1rem;
    font-weight: 700;
    border-radius: 4px;
    padding: 2px 7px;
    margin-right: 8px;
    vertical-align: middle;
    line-height: 1.6;
}

/* 메타 정보 영역 */
.info_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 0;
    border-top: 1px solid #e0e0e0;
}

.info-left {
    display: flex;
    gap: 20px;
}

.info-left p,
.info-right p {
    font-size: 1.4rem;
    color: #666;
    font-weight: 600;
    margin: 0;
}

.info-left p span,
.info-right p span {
    font-size: 1.4rem;
    color: #333;
    font-weight: 400;
    margin-left: 4px;
}

/* 본문 박스 */
.notice-content {
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #fafafa;
    padding: 24px 28px;
    min-height: 200px;
    margin: 20px 0 24px;
    line-height: 1.9;
    font-size: 1.4rem;
    color: #333;
    word-break: break-word;
}

.notice-content >>> img {
    max-width: 100%;
    height: auto;
}

/* 첨부파일 영역 */
.file_area {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 13px 18px;
    border: 1px solid #c9daf8;
    border-radius: 8px;
    background-color: #eef3fc;
    margin-bottom: 24px;
}

.file-label {
    font-size: 1.3rem;
    font-weight: 700;
    color: #3d5a99;
    white-space: nowrap;
}

.file-link {
    font-size: 1.3rem;
    color: #3d5a99;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 6px;
}

.file-link:hover {
    text-decoration: underline;
    color: #1e3a70;
}
</style>